<script>
import { GetKeFuByHost } from "../../../lib/request"
export default {
  name: "CustomerService",
  created() {
    GetKeFuByHost({}, (res) => {
      const { Result, ResultDescription } = res
      if (!ResultDescription && Result.KefuType !== 0) {
        const { KefuType, KefuCode } = Result
        let _url = ""
        switch (KefuType) {
          case 1:
            //CC客服
            _url = `http://kefu.ziyun.com.cn/vclient/?webid=${encodeURIComponent(KefuCode)}`
            break
          case 2:
            //53客服
            _url = `https://tb.53kf.com/code/code/${KefuCode}`
            break
          case 3:
            //百度
            _url = `http://hm.baidu.com/hm.js?${KefuCode}`
            break
          case 4:
            //乐语
            _url = `http://lead.soperson.com/${KefuCode}.js`
            break
          case 5:
            //企业QQ
            _url = `http://wpa.b.qq.com/cgi/wpa.php?key=${KefuCode}`
            break
        }
        let _script = document.createElement("script")
        _script.type = "text/javascript"
        _script.src = _url
        document.getElementsByTagName("head")[0].appendChild(_script)
      }
    })
  }
}
</script>